import { useCompanyTypeStore } from './company-type-store';
import { useProjectDetailsStore } from './project-details.store';
import { useNDAUploadStore } from '../features/nda/stores/nda-upload.store';
import { usePOUploadStore } from '../features/my-services/stores/po-upload.store';
import { useSOWFormStore } from '../features/my-services/stores/sow-form-store';
import { useSCUploadStore } from '../features/my-services/stores/sc-upload.store';
import { useServiceDetailsStore } from '../features/my-services/stores/service-details.store';
import { useDocumentAttestationStore } from '../features/my-services/business-landing/stores/document-attestation.store';
import { useGeneralManagerInformationStore } from '../features/my-services/business-landing/stores/general-manager-information.store';

const PERSISTED_STORES = [
  useCompanyTypeStore,
  useProjectDetailsStore,
  useNDAUploadStore,
  usePOUploadStore,
  useSOWFormStore,
  useSCUploadStore,
  useServiceDetailsStore,
  useDocumentAttestationStore,
  useGeneralManagerInformationStore,
] as const;

type PersistedStore = { persist: { clearStorage: () => void } };

/**
 * Clears sessionStorage for every Zustand persisted store.
 * Uses the Zustand persist API rather than hardcoded key strings so this
 * stays correct automatically when stores are added or renamed.
 */
export const clearAllPersistedStores = (): void => {
  PERSISTED_STORES.forEach((store) =>
    (store as unknown as PersistedStore).persist.clearStorage()
  );
};
